module.exports = __webpack_public_path__ + "media/images/weather/56_day-1a77f4a96c21efb3e44340540b043b0d.png";